// extracted by mini-css-extract-plugin
export default {"question-icon":"QuestionIcon_question-icon__3k56-"};